import { render, staticRenderFns } from "./CUCheckBox.vue?vue&type=template&id=b93e9ee4"
import script from "./CUCheckBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CUCheckBox.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports